import React from "react";

const Form = ({ tipo, errors }) => {
    return (
        <div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>Nombre:</label>
                </div>
                <div className='col col-md-7'>
                    <input
                        type='text'
                        className='text-input form-control'
                        id='nombre'
                        name='nombre'
                        defaultValue={tipo.nombre}
                    />
                    {errors.nombre && (
                        <small className='help-blockParams form-Text'>
                            {errors.nombre[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>Tipo:</label>
                </div>
                <div className='col-md-7'>
                    <select
                        className='text-input form-control'
                        id='tipo_nomina'
                        name='tipo_nomina'
                        defaultValue={tipo.tipoNomina}>
                        <option>Seleccionar</option>
                        <option value='fijo'>Sueldo Fijo</option>
                        <option value='produccion'>Producción</option>
                        <option value='fijo-produccion'>Sueldo Fijo + Producción</option>
                    </select>
                    {errors.tipo_nomina && (
                        <small className='help-blockParams form-Text'>
                            {errors.tipo_nomina[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Sueldo Fijo:
                    </label>
                </div>
                <div className='col-md-7'>
                    <input
                        type='number'
                        step='0.01'
                        className='text-input form-control'
                        id='sueldo_fijo'
                        name='sueldo_fijo'
                        defaultValue={tipo.sueldoFijo}
                    />
                    {errors.sueldoFijo && (
                        <small className='help-blockParams form-Text'>
                            {errors.sueldoFijo[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Descuento TSS:
                    </label>
                </div>
                <div className='col-md-7'>
                    <input
                        type='number'
                        className='text-input form-control'
                        id='descuento'
                        name='descuento'
                        step='0.01'
                        defaultValue={tipo.descuento}
                    />
                    {errors.descuento && (
                        <small className='help-blockParams form-Text'>
                            {errors.descuento[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Form;
